<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="text-center m-t-lg">
          <div v-if="canViewMessages" class="col-lg-3">
            <div class="ibox float-e-margins">
              <div class="ibox-title">
                <router-link
                  :to="{
                    name: 'MessagesList',
                    query: { responsible_person_name: currentAdmin },
                  }"
                >
                  <span class="label label-success pull-right">
                    Moje sprawy
                  </span>
                </router-link>
                <h5>Ilość Twoich spraw</h5>
              </div>
              <div class="ibox-content">
                <h1 class="no-margins">{{ myCasesCount }}</h1>
              </div>
            </div>
          </div>
          <div v-if="canViewMessages" class="col-lg-3">
            <div class="ibox float-e-margins">
              <div class="ibox-title">
                <router-link :to="{ name: 'MessagesList' }">
                  <span class="label label-success pull-right">Wszystkie</span>
                </router-link>
                <h5>Wszystkie sprawy</h5>
              </div>
              <div class="ibox-content">
                <h1 class="no-margins">{{ allCasesCount }}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <KsefUnsentInvoicesModal
    v-if="showUnsentInvoicesModal"
    :count="unsentInvoicesCount"
    @callbackClose="showUnsentInvoicesModal = false"
  />
</template>

<script>
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useCookies } from "vue3-cookies";
import KsefUnsentInvoicesModal from "../ksef/KsefUnsentInvoicesModal.vue";
import { hasPermission } from "../../permissions";
import { invoicePermissionsConst } from "../../constants/orderConstants";
import { clientcontactPermissionsConst } from "../../constants/settingConstants";

export default {
  name: "HomePage",
  mixins: [],
  components: { KsefUnsentInvoicesModal },
  props: {},
  setup() {
    const store = useStore();
    const { cookies } = useCookies();
    // Both tiles count client contacts and link to the messages list, so they
    // carry nothing for a user without that permission - and the counters they
    // would ask for come back as 403 anyway. The dashboard itself stays
    // reachable and simply renders empty.
    const canViewMessages = computed(() =>
      hasPermission(clientcontactPermissionsConst.view)
    );
    const myCasesResponse = computed(
      () => store.getters.getHomeMyMessagesCountData
    );
    const allCasesResponse = computed(
      () => store.getters.getHomeAllMessagesCountData
    );
    const myCasesCount = ref(0);
    const allCasesCount = ref(0);
    const currentAdmin = ref(cookies.get("CPadmin") || "");
    const unsentInvoicesCount = ref(0);
    const showUnsentInvoicesModal = ref(false);
    const ksefUnsentInvoicesData = computed(
      () => store.getters.getKsefUnsentInvoicesData
    );

    const extractCount = (responseData) => {
      if (typeof responseData === "number") {
        return responseData;
      }

      if (Array.isArray(responseData)) {
        return responseData.length;
      }

      if (responseData && typeof responseData.count === "number") {
        return responseData.count;
      }

      if (responseData && Array.isArray(responseData.results)) {
        return responseData.results.length;
      }

      return 0;
    };

    const getMyCasesCount = () => {
      store.dispatch("getHomeMyMessagesCount");
    };

    const getAllCasesCount = () => {
      store.dispatch("getHomeAllMessagesCount");
    };

    const checkUnsentInvoices = () => {
      if (!sessionStorage.getItem("showUnsentInvoicesModal")) {
        return;
      }

      // The modal only leads to the invoice list - pointless without the
      // permission to open it.
      if (!hasPermission(invoicePermissionsConst.view)) {
        sessionStorage.removeItem("showUnsentInvoicesModal");
        return;
      }

      sessionStorage.removeItem("showUnsentInvoicesModal");
      store.dispatch("getKsefUnsentInvoicesCount");
    };

    onMounted(() => {
      if (canViewMessages.value) {
        getMyCasesCount();
        getAllCasesCount();
      }
      checkUnsentInvoices();
    });

    watch(
      () => myCasesResponse.value,
      function (newValue) {
        myCasesCount.value = extractCount(newValue?.data);
      }
    );

    watch(
      () => allCasesResponse.value,
      function (newValue) {
        allCasesCount.value = extractCount(newValue?.data);
      }
    );

    watch(
      () => ksefUnsentInvoicesData.value,
      function (newValue) {
        if (newValue && newValue.status === 200 && newValue.data?.count > 0) {
          unsentInvoicesCount.value = newValue.data.count;
          showUnsentInvoicesModal.value = true;
        }
      }
    );

    return {
      canViewMessages,
      myCasesCount,
      allCasesCount,
      currentAdmin,
      unsentInvoicesCount,
      showUnsentInvoicesModal,
    };
  },
};
</script>
